module.exports = __webpack_public_path__ + "static/media/insPicOne.4c3a3103.jpg";